<template>
    <v-btn v-if="loggedIn"
    class="ml-2"
    min-width="0"
    text
    to="/Account"
    exact
    >
        <v-icon>mdi-account</v-icon>
        Mon compte
    </v-btn>
</template>

<script>
export default {
    name: 'DefaultUserPage',
    computed: {
        loggedIn () {
            const value = this.$store.state.auth.state.status.loggedIn
            return value
        }
    }
}
</script>
  